import { render, staticRenderFns } from "./AgendaNumbering.vue?vue&type=template&id=16d13a08&scoped=true&"
import script from "./AgendaNumbering.vue?vue&type=script&lang=js&"
export * from "./AgendaNumbering.vue?vue&type=script&lang=js&"
import style0 from "./AgendaNumbering.vue?vue&type=style&index=0&id=16d13a08&scoped=true&lang=css&"
import style1 from "./AgendaNumbering.vue?vue&type=style&index=1&id=16d13a08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d13a08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VList,VListItem,VListItemAction,VListItemContent,VListItemGroup,VListItemSubtitle,VListItemTitle,VRadio})
